export interface AdditionalModalAdminViewProps {
    headerTitle?: string;
    text?: string;
    isShow: boolean;
    showPreloader?: boolean;
    onClose: () => void;
    onSubmit: (fields: Record<DeclineFormKeys, string>) => void;
}

export enum DeclineFormKeys {
    Comment = 'decline-comment',
}

export interface DeclineFormFields {
    [DeclineFormKeys.Comment]: string;
}
